import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const Fieldset = styled.fieldset`
  ${tw`flex items-center flex-1 gap-2`}
`;

const Input = styled.input`
  ${tw`inline-flex items-center justify-center flex-1 w-full border border-slate-400 rounded px-2.5 py-1.5 text-sm leading-none text-slate-800 shadow-slate-300 outline-none`}

  &:focus: {
    ${tw`shadow-[0_0_0_4px_rgb(var(--color-primaryValues)_/_0.2)] border-primary`}
  }
`;

const Label = styled.label`
  ${tw`text-slate-500 text-sm w-auto`}
`;

interface Props {
  value: number;
  max: number;
  min: number;
  label?: string;
  className?: string;
  type?: 'number' | 'decimal';
  handleValueChange: (value: number) => void;
}

const NumberInput: FC<Props> = ({
  label,
  min,
  value,
  max,
  type = 'number',
  className,
  handleValueChange,
}) => {
  const onHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const newValue =
      type === 'decimal' ? parseFloat(rawValue) : parseInt(rawValue, 10);
    handleValueChange(newValue || 0);
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <Fieldset className={className}>
      <Input
        id={label}
        type={type}
        step={type === 'decimal' ? 0.1 : 1}
        onChange={onHandleChange}
        min={min}
        max={max}
        value={value.toString()}
      />
      {label && <Label htmlFor={label}>{label}</Label>}
    </Fieldset>
  );
};

export default NumberInput;
